import "./CostSummaryHeader.css";

import { useState } from "react";
import { useSelector } from "react-redux";

import HeaderVisibleButton from "components/HeaderVisibleButton";
import LabelNormWithUnder from "components/UI/LabelNormWithUnder";
import { LabelTwoVerticalLevel } from "components/UI/labels";
import { getCostSummaryHeaderData } from "slices/costSummary/costSummarySelectors";

const CostSummaryHeader = ({ refBlocks }) => {
	const data = useSelector(getCostSummaryHeaderData);
	const [headerFullVisible, setHeaderFullVisible] = useState(true);

	return (
		<div className="CostSummaryHeader">
			<div className="OuterHeadHidable" ref={refBlocks.headBlock1}>
				<div>
					<LabelNormWithUnder norm="Наименование программного продукта" under={data.soft_name_print} />
					<LabelTwoVerticalLevel main={data.customer} second="(заказчик)" />
					<LabelNormWithUnder norm="Утверждена" under={data.approved} />
					<LabelNormWithUnder norm="Сводка затрат в сумме" under={data.summary_print} />
					<LabelTwoVerticalLevel main={data.approved_print} second="(ссылка на документ об утверждении)" />
				</div>
			</div>
			<div className="TableOuterHeadMainTitle">
				<div className="HeadFlex">
					<div className="TitleCenter">
						<span>СВОДКА ЗАТРАТ</span>
						<HeaderVisibleButton
							fullVisible={headerFullVisible}
							setHeaderFullVisible={setHeaderFullVisible}
							maxHeight={"195px"}
							headersRef={[refBlocks.headBlock1.current, refBlocks.headBlock2.current]}
						/>
					</div>
				</div>
			</div>
			<div className="OuterHeadHidable" ref={refBlocks.headBlock2}>
				<div>
					<LabelTwoVerticalLevel main={data.construction_site} second="(наименование стройки)" />
					<LabelTwoVerticalLevel main={data.object_name} second="(наименование объекта капитального строительства)" />
					<LabelNormWithUnder norm="Составлена в текущем уровне цен" under={data.pricelevel_print} />
				</div>
			</div>
		</div>
	);
};

export default CostSummaryHeader;
